import './CustomCheckBox.scss'

export function CustomCheckBox({ checked, onClick }) {
    return <input onClick={onClick} checked={checked} className='custom_checkbox' type="checkbox" name="checkbox" />
}